import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.039 10.809a.7.7 0 0 1 .7.7v3.054l.771-.802a.7.7 0 0 1 1.01.97l-1.977 2.054a.7.7 0 0 1-1 .01L7.49 14.74a.7.7 0 0 1 .99-.99l.859.859v-3.101a.7.7 0 0 1 .7-.7ZM10.045 3a.7.7 0 0 1 .498.215l1.976 2.053a.7.7 0 1 1-1.008.97l-.772-.801V8.49a.7.7 0 1 1-1.4 0V5.39l-.859.858a.7.7 0 1 1-.99-.99l2.054-2.053A.7.7 0 0 1 10.045 3Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
